<div class="layout-topbar">
  <div class="topbar-left">
    <a tabindex="0" #menubutton type="button" class="menu-button" (click)="onMenuButtonClick()">
      <i class="pi pi-chevron-left"></i>
    </a>
    <h4 class="qb-page-title" app-page-title></h4>
    <img class="horizontal-logo" src="/layout/images/logo-white.svg" alt="diamond-layout" />
    <span class="topbar-separator"></span>
    <div app-breadcrumb></div>
    <img class="mobile-logo" src="/layout/images/logo-{{ isDarkTheme() ? 'white' : 'dark' }}.svg"
      alt="diamond-layout" />
  </div>

  <div class="topbar-right">
    <ul class="topbar-menu">
      <!-- <li class="right-sidebar-item">
        <a class="right-sidebar-button" (click)="toggleSearchBar()">
          <i class="pi pi-search"></i>
        </a>
      </li> -->
      <li class="right-sidebar-item">
        <button class="right-sidebar-button" (click)="onConfigButtonClick()"><i class="pi pi-cog"></i></button>
      </li>
      <li class="right-sidebar-item">
        <a class="right-sidebar-button" (click)="showNotifications()">
          <i *ngIf="!newNotificationsCount" class="pi pi-bell"></i>
          <i *ngIf="newNotificationsCount" class="pi pi-bell mt-2" pBadge
            value="{{newNotificationsCount.toString()}}"></i>
        </a>
      </li>
      <li class="profile-item static sm:relative">
        <a id="userMenu" class="right-sidebar-button relative z-50" pStyleClass="@next" enterFromClass="hidden"
          enterActiveClass="animate-scalein" leaveActiveClass="animate-fadeout" leaveToClass="hidden"
          [hideOnOutsideClick]="true">
          <p-avatar [image]="gravatarLink" size="large" shape="circle" />
          <span class="profile-name text-lg ml-2">{{ userDisplayName }}</span>
        </a>
        <div
          class="list-none p-2 m-0 rounded-2xl border border-surface overflow-hidden absolute bg-surface-0 dark:bg-surface-900 hidden origin-top w-52 mt-2 right-0 z-[999] top-auto shadow-[0px_56px_16px_0px_rgba(0,0,0,0.00),0px_36px_14px_0px_rgba(0,0,0,0.01),0px_20px_12px_0px_rgba(0,0,0,0.02),0px_9px_9px_0px_rgba(0,0,0,0.03),0px_2px_5px_0px_rgba(0,0,0,0.04)]">
          <ul class="flex flex-col gap-1">
            <li>
              <a (click)="showProfile()"
                class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer">
                <i class="pi pi-user"></i>
                <span>Profile</span>
              </a>
            </li>
            <li>
              <a (click)="setGravatar()"
                class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer">
                <i class="fa-duotone fa-regular fa-user-tie-hair"></i>
                <span>Avatar</span>
              </a>
            </li>
            <li>
              <a (click)="showNotifications()"
                class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer">
                <i class="pi pi-inbox"></i>
                <span>Inbox</span>
              </a>
            </li>
            <li>
              <a (click)="changePassword()" [title]="saveChangesTooltip"
                class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer">
                <i class="pi pi-wrench"></i>
                <span>Change Password</span>
              </a>
            </li>
            <li>
              <a (click)="logout()" [title]="saveChangesTooltip"
                class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer">
                <i class="pi pi-power-off"></i>
                <span>Log out</span>
              </a>
            </li>
            <li>
              <a *ngIf="canImpersonate()" [title]="saveChangesTooltip" (click)="impersonate()"
                class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer">
                <i class="pi pi-user"></i>
                <span>Impersonate</span>
              </a>
            </li>
            <li>
              <a *ngIf="canStopImpersonation()" [title]="saveChangesTooltip" (click)="stopImpersonation()"
                class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer">
                <i class="pi pi-user"></i>
                <span>Stop Impersonation</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
      <!-- <li class="right-sidebar-item">
        <a tabindex="0" class="right-sidebar-button" (click)="showRightMenu()">
          <i class="pi pi-align-right"></i>
        </a>
      </li> -->
    </ul>
  </div>
</div>